'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reactIntl = require('react-intl');

var _components = require('../../components');

var _BaseButton = require('../../components/BaseButton/BaseButton');

var _DefaultString = require('../../helpers/DefaultString');

var _Product = require('../../helpers/Product');

var _Router = require('../../helpers/Router');

var _auth = require('../../redux/modules/auth');

var _LoginSignUp = require('./LoginSignUp.scss');

var _LoginSignUp2 = _interopRequireDefault(_LoginSignUp);

var _Features = require('../../helpers/Features');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var expertlyCuratedImage = require('../../../res/images/welcome/expertly_curated.png');
var onTheGoImage = require('../../../res/images/welcome/on_the_go.png');
var unlimitedSkipsImage = require('../../../res/images/welcome/unlimited_skips.png');

var LoginSignUp = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo,
    auth: state.auth
  };
}, { forceChooseProvider: _auth.forceChooseProvider, editAutoGracePeriod: _auth.editAutoGracePeriod, pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(LoginSignUp, _Component);

  function LoginSignUp() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LoginSignUp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LoginSignUp.__proto__ || (0, _getPrototypeOf2.default)(LoginSignUp)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      location: null
    }, _this.freeTrial = function () {
      _this.props.editAutoGracePeriod(true);
    }, _this.login = function () {
      if (_this.isMusic()) {
        _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.LoginEmail));
      } else {
        _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.LoginOptions));
      }
    }, _this.signUp = function () {
      _this.props.forceChooseProvider(true);
    }, _this.signUpFreeMode = function () {
      _this.goToSignUp();
    }, _this.isMusic = function () {
      return _this.props.auth.productName === _Product.PRODUCT_NAMES.Music;
    }, _this.isKaraokeTsm = function () {
      return (0, _Product.getThemedProduct)(_this.props.auth.productName, _this.props.auth.clientId) === _Product.PRODUCT_NAMES.KaraokeTsm;
    }, _this.goToSignUp = function () {
      if (_this.isMusic()) {
        _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.SignUpEmail));
      } else {
        _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.SignUpOptions));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LoginSignUp, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.forceChooseProvider(false);
      this.props.editAutoGracePeriod(false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.forceChooseProvider !== nextProps.auth.forceChooseProvider && nextProps.auth.forceChooseProvider || this.props.auth.autoGracePeriod !== nextProps.auth.autoGracePeriod && nextProps.auth.autoGracePeriod) {
        this.goToSignUp();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$auth = this.props.auth,
          productName = _props$auth.productName,
          clientId = _props$auth.clientId,
          realm = _props$auth.realm,
          location = _props$auth.location;
      var formatMessage = this.props.intl.formatMessage;

      var appInfo = this.props.appInfo;
      var features = appInfo.features;
      var freeModeAvailable = features && features.indexOf(_Features.FeaturesListConst.FreeModeAvailable) !== -1;
      var isMusicProduct = this.isMusic();
      var isKaraokeProduct = productName === _Product.PRODUCT_NAMES.Karaoke;
      var countriesWithUnlimitedSkips = appInfo.countriesWithUnlimitedSkips;
      var country = location && location.city && location.city.country ? location.city.country.iso_code : '';
      var hasUnlimitedSkips = countriesWithUnlimitedSkips.indexOf(country) !== -1;
      var showHeader = location;

      return _react2.default.createElement(
        'div',
        { className: _LoginSignUp2.default.loginSignUpContainer },
        _react2.default.createElement(
          'div',
          { className: _LoginSignUp2.default.loginSignUpContent },
          _react2.default.createElement(
            'div',
            { className: _LoginSignUp2.default.content },
            isMusicProduct ? _react2.default.createElement(
              'div',
              { className: _LoginSignUp2.default.header },
              showHeader ? _react2.default.createElement(
                'div',
                { className: _LoginSignUp2.default.headerLeft },
                _react2.default.createElement('img', { src: expertlyCuratedImage }),
                _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ExpertlyCurated)
              ) : null,
              showHeader && hasUnlimitedSkips ? _react2.default.createElement('div', { className: _LoginSignUp2.default.headerSeparator }) : null,
              showHeader && hasUnlimitedSkips ? _react2.default.createElement(
                'div',
                { className: _LoginSignUp2.default.headerMiddle },
                _react2.default.createElement('img', { src: unlimitedSkipsImage }),
                _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.UnlimitedSkips)
              ) : null,
              showHeader ? _react2.default.createElement('div', { className: _LoginSignUp2.default.headerSeparator }) : null,
              showHeader ? _react2.default.createElement(
                'div',
                { className: _LoginSignUp2.default.headerRight },
                _react2.default.createElement('img', { src: onTheGoImage }),
                _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.OnTheGo)
              ) : null
            ) : _react2.default.createElement(
              'div',
              { className: _LoginSignUp2.default.title },
              _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _DefaultString.translations.UniversalLoginTitle, {
                values: { product: formatMessage((0, _Product.getProductName)(realm, productName, clientId)) }
              }))
            ),
            _react2.default.createElement(
              'div',
              { className: _LoginSignUp2.default.optionsContainer },
              !isKaraokeProduct && (freeModeAvailable ? _react2.default.createElement(_components.BaseButton, {
                className: _LoginSignUp2.default.freeModeButton,
                onClick: this.signUpFreeMode,
                buttonString: _DefaultString.translations.SignUpFreeMode,
                theme: _BaseButton.ButtonTheme.CallToAction
              }) : _react2.default.createElement(_components.BaseButton, {
                className: _LoginSignUp2.default.freeTrialButton,
                onClick: isMusicProduct ? this.signUp : this.freeTrial,
                buttonString: isMusicProduct ? _DefaultString.translations.SignUpProvider : _DefaultString.translations.FreeTrial,
                theme: _BaseButton.ButtonTheme.CallToAction
              })),
              !isMusicProduct ? _react2.default.createElement(_components.BaseButton, { className: _LoginSignUp2.default.button, onClick: this.signUp, buttonString: _DefaultString.translations.SignUp }) : null,
              _react2.default.createElement(_components.BaseButton, { className: _LoginSignUp2.default.button, onClick: this.login, buttonString: _DefaultString.translations.Login }),
              isMusicProduct && freeModeAvailable ? _react2.default.createElement(
                'div',
                { className: _LoginSignUp2.default.providerLogin, onClick: this.signUp },
                _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.MusicFreeAccessWithProvider)
              ) : null
            )
          )
        )
      );
    }
  }]);
  return LoginSignUp;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  forceChooseProvider: _react.PropTypes.func,
  editAutoGracePeriod: _react.PropTypes.func,
  intl: _reactIntl.intlShape.isRequired,
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(LoginSignUp);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/LoginSignUp/LoginSignUp.js
// module id = 2012
// module chunks = 0